export function sortByDate(data: any, key: string) {
  return data.sort(function (a: any, b: any) {
    return new Date(b[key]).getTime() - new Date(a[key]).getTime()
  })
}
